export function openInvoicePrintWindow() {
  const popup = window.open("", "_blank", "width=900,height=720");
  if (!popup) throw new Error("Allow the print window, then retry printing");
  popup.document.write(
    "<!doctype html><html><body style='font:14px sans-serif;padding:24px'>Preparing invoice…</body></html>",
  );
  popup.document.close();
  return popup;
}

export function printHtmlArtifact(
  html: string,
  target?: Window | null,
): Promise<Window> {
  const popup = target && !target.closed ? target : openInvoicePrintWindow();
  popup.document.open();
  popup.document.write(html);
  popup.document.close();
  popup.focus();
  return new Promise((resolve, reject) => {
    let dialogOpened = false;
    const timeout = window.setTimeout(() => {
      reject(new Error("The operating-system print dialog did not open"));
    }, 10_000);
    const openDialog = () => {
      if (dialogOpened) return;
      dialogOpened = true;
      try {
        popup.print();
        window.clearTimeout(timeout);
        resolve(popup);
      } catch (error) {
        window.clearTimeout(timeout);
        reject(error);
      }
    };
    popup.addEventListener("load", openDialog, { once: true });
    if (popup.document.readyState === "complete") {
      window.setTimeout(openDialog, 50);
    }
  });
}
